export function getResultListItems<T extends { objectID: string }>({
  results = [],
  highlightedItems,
  highlightedOnly,
  variant = "faceted",
}: {
  results?: T[];
  highlightedItems?: T[] | null;
  highlightedOnly?: boolean | null;
  variant?: "faceted" | "grid" | "carousel";
}): T[] {
  const highlightedIds = new Set(
    highlightedItems?.map(({ objectID }) => objectID),
  );
  const items = highlightedOnly
    ? (highlightedItems ?? [])
    : [
        ...(highlightedItems ?? []),
        ...results.filter((item) => !highlightedIds.has(item.objectID)),
      ];

  if (variant !== "carousel") return items;
  return items.slice(0, highlightedItems?.length || 10);
}
